import React, { useState } from 'react';

const PersonalInfoPage = () => {
    const [personalInfo, setPersonalInfo] = useState({
        name: "Your Name",
        email: "youremail@example.com",
        bio: "A brief bio about your professional background and interests."
    });

    return (
        <div className="container mx-auto mt-10 p-5 bg-white rounded shadow-lg">
            <h1 className="text-2xl font-bold text-center">About Me</h1>
            <div className="mt-4">
                <p className="text-xl"><strong>Name:</strong> {personalInfo.name}</p>
                <p className="text-xl"><strong>Email:</strong> {personalInfo.email}</p>
                <p className="text-xl"><strong>Bio:</strong> {personalInfo.bio}</p>
            </div>
        </div>
    );
}

export default PersonalInfoPage;
